import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiChevronDown } = FiIcons;

const faqs = [
  {
    q: "When should a company book a Christmas party venue?",
    a: "For prime December dates (especially Thursdays, Fridays, and Saturdays), we highly recommend booking by late summer or early fall. The best dates often secure 4-6 months in advance."
  },
  {
    q: "Can Padua Weddings host corporate holiday parties?",
    a: "Absolutely. While known as a historic estate, Padua Weddings is fully equipped to host elevated corporate events, offering comprehensive catering, bar service, and customizable layouts perfect for company celebrations."
  },
  {
    q: "Is Padua Weddings only for weddings?",
    a: "No. Padua Weddings is a versatile Spanish Revival event venue. During the week and especially throughout the holiday season, we transition beautifully into a sophisticated setting for corporate dinners, galas, and appreciation events."
  },
  {
    q: "What types of company events work well at the estate?",
    a: "We frequently host employee appreciation dinners, end-of-year company parties, leadership retreats, client appreciation events, and departmental celebrations."
  },
  {
    q: "Can companies book a private tour before choosing a date?",
    a: "Yes. We encourage event planners, HR managers, and executives to schedule a private tour of Padua Weddings to walk the grounds, discuss logistics, and visualize the event flow."
  },
  {
    q: "What cities does Padua Weddings serve?",
    a: "Located in Claremont, we conveniently serve Upland, Rancho Cucamonga, Ontario, Pasadena, and surrounding business hubs in the Inland Empire and San Gabriel Valley."
  }
];

const FAQItem = ({ faq, isOpen, toggle }) => (
  <div className="border-b border-olive-sage/20">
    <button 
      onClick={toggle}
      className="w-full py-6 flex justify-between items-center text-left focus:outline-none group"
    >
      <span className={`font-serif text-lg transition-colors duration-300 ${isOpen ? 'text-antique-gold' : 'text-mission-green group-hover:text-olive-sage'}`}>{faq.q}</span>
      <motion.div animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.2 }}>
        <SafeIcon icon={FiChevronDown} className={`${isOpen ? 'text-antique-gold' : 'text-olive-sage'} text-xl`} />
      </motion.div>
    </button>
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="overflow-hidden"
        >
          <p className="pb-6 text-mission-green/70 leading-relaxed text-base">
            {faq.a}
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

const FAQ = () => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section className="py-32 bg-limestone-warm">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-serif text-3xl md:text-4xl text-mission-green mb-4">
            Frequently Asked Questions
          </h2>
          <div className="h-0.5 w-16 bg-antique-gold mx-auto"></div>
        </div>
        
        <div className="bg-spanish-ivory p-4 md:p-10 rounded-xl shadow-sm border border-olive-sage/10">
          {faqs.map((faq, idx) => (
            <FAQItem 
              key={idx} 
              faq={faq} 
              isOpen={openIdx === idx} 
              toggle={() => setOpenIdx(openIdx === idx ? -1 : idx)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;